function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState, useEffect, useRef } from 'react';
import { Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Table } from '@rd-web-markets/shared/dist/util';
import shareholdersService from '../../../../services/elster/shareholders.service';
import ShareholderForm from './ShareholderForm';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { Loader } from '@rd-web-markets/shared/dist/util/Loader';
import { AddButton, DeleteButtonSquare } from '@rd-web-markets/shared/dist/util/buttons';
import { SELECTED_ROW_DIMMED_CLASS } from '../../../../constants';
const INTEGER_FIELDS = ['ocsce_total_remun_for_shareholders', 'ocsce_total_remun_for_project', 'ocsce_total_working_hours_shareholder_on_project', 'ocsce_total_wh_shareholder_not_in_20_26', 'ocsce_total_wh_shareholder_in_20_26', 'ocsce_total_wh_shareholder_before_28_03_2024', 'ocsce_total_wh_shareholder_after_27_03_2024'];
const EMPTY_SHAREHOLDER = {
  name: '',
  ocsce_is_civil_agreement: null,
  ocsce_total_remun_for_shareholders: null,
  ocsce_total_remun_for_project: null,
  ocsce_total_working_hours_shareholder_on_project: null,
  ocsce_total_wh_shareholder_not_in_20_26: null,
  ocsce_total_wh_shareholder_in_20_26: null,
  ocsce_total_wh_shareholder_before_28_03_2024: null,
  ocsce_total_wh_shareholder_after_27_03_2024: null
};
const Shareholders = _ref => {
  var _selectedProject$proj;
  let {
    selectedProject,
    isVersion8
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    search
  } = useLocation();
  const [listLoading, setListLoading] = useState(false);
  const [detailLoading, setDetailLoading] = useState(false);
  const [selectedShareholder, setSelectedShareholder] = useState(null);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const hasFetchedRef = useRef(false);
  const projectElsterDetailId = selectedProject === null || selectedProject === void 0 || (_selectedProject$proj = selectedProject.project_elster_detail) === null || _selectedProject$proj === void 0 ? void 0 : _selectedProject$proj.id;
  const {
    shareholders,
    setShareholders,
    fetchShareholders,
    shareholder,
    setShareholder,
    fetchShareholder,
    updateShareholder,
    createShareholder,
    deleteShareholder
  } = shareholdersService.useCrud(projectElsterDetailId, setListLoading, setDetailLoading, setSelectedShareholder, false);
  const isShareholdersTabActive = new URLSearchParams(search).get('sub_tab1') === 'shareholders';
  useEffect(() => {
    // handle fetching shareholders
    if (isShareholdersTabActive && projectElsterDetailId && !hasFetchedRef.current) {
      hasFetchedRef.current = true;
      fetchShareholders();
    }
    if (!isShareholdersTabActive || !projectElsterDetailId) {
      hasFetchedRef.current = false;
    }
  }, [isShareholdersTabActive, projectElsterDetailId, fetchShareholders]);
  useEffect(() => {
    // handle clearing selected shareholder and shareholder when tab is not active
    !isShareholdersTabActive && setSelectedShareholder(null) && setShareholder(null);
  }, [isShareholdersTabActive, setSelectedShareholder, setShareholder]);
  const editShareholder = (e, shareholderId) => {
    e.preventDefault();
    if ((shareholder === null || shareholder === void 0 ? void 0 : shareholder.id) !== shareholderId) {
      fetchShareholder({
        projectElsterDetailId,
        shareholderId
      });
    }
    setHasUnsavedChanges(false);
    setSelectedShareholder(shareholderId);
  };
  const closeForm = () => {
    setHasUnsavedChanges(false);
    setSelectedShareholder(null);
    setShareholder(null);
  };
  const deleteShareholderHandler = async shareholderToDelete => {
    if (window.confirm(t("".concat(window.MARKET_CONSTANTS.DELETE_CONFIRMATION_MESSAGE)) + ': ' + shareholderToDelete.name)) {
      closeForm();
      deleteShareholder(shareholderToDelete);
    }
  };
  const change = e => {
    let value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    if (INTEGER_FIELDS.includes(e.target.name) && value !== '') {
      value = parseInt(value, 10);
    }
    setHasUnsavedChanges(true);
    setShareholder(_objectSpread(_objectSpread({}, shareholder), {}, {
      [e.target.name]: value
    }));
  };
  const submit = async () => {
    if (!shareholder) return;
    if (!shareholder.id) {
      await createShareholder(shareholder);
    } else {
      await updateShareholder(shareholder);
    }
    setHasUnsavedChanges(false);
  };
  if (listLoading) return /*#__PURE__*/React.createElement(Loader, {
    type: "spinner"
  });
  const headers = [{
    text: t('name')
  }, {
    text: t('open_shareholder_detail')
  }, {
    text: t('delete')
  }];
  const buildRow = shareholderItem => {
    const columns = [shareholderItem.name, /*#__PURE__*/React.createElement("a", {
      href: "#",
      onClick: e => editShareholder(e, shareholderItem.id)
    }, t('to_shareholder_details')), /*#__PURE__*/React.createElement(DeleteButtonSquare, {
      key: "delete-".concat(shareholderItem.id),
      onClick: () => deleteShareholderHandler(shareholderItem)
    })];
    return {
      key: shareholderItem.id,
      columns: columns,
      className: "text-center ".concat(shareholderItem.id === selectedShareholder ? SELECTED_ROW_DIMMED_CLASS : '')
    };
  };
  const rows = (shareholders === null || shareholders === void 0 ? void 0 : shareholders.map(shareholderItem => buildRow(shareholderItem))) || [];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, {
    className: "justify-content-end pb-3"
  }, !selectedShareholder && /*#__PURE__*/React.createElement(AddButton, {
    onClick: () => {
      setHasUnsavedChanges(false);
      setSelectedShareholder('new');
      setShareholder(_objectSpread({}, EMPTY_SHAREHOLDER));
    },
    variant: "primary",
    text: t('add_new_shareholder'),
    className: "mx-2"
  })), !(shareholders !== null && shareholders !== void 0 && shareholders.length) && !selectedShareholder ? /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("div", {
    className: "text-center p-3"
  }, t('no_shareholders_found'))) : /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Table, {
    headers: headers,
    rows: rows,
    headerStyle: {
      textAlign: 'center'
    },
    opts: {
      bordered: false,
      striped: false,
      responsive: false,
      hover: true
    },
    showControls: false
  })), selectedShareholder && /*#__PURE__*/React.createElement(ShareholderForm, {
    shareholder: shareholder,
    closeForm: closeForm,
    loading: detailLoading,
    change: change,
    submit: submit,
    hasUnsavedChanges: hasUnsavedChanges,
    isVersion8: isVersion8
  }));
};
export default Shareholders;